import { ArrowRight } from "lucide-react";

const TOOLS = [
  "QuickBooks", "Xero", "FreshBooks", "Wave", "Sage",
  "Jobber", "ServiceTitan", "Housecall Pro", "FieldEdge",
  "HubSpot", "Salesforce", "Pipedrive", "Zoho",
  "Monday", "Copper", "Close", "Attio",
  "folk", "Affinity", "Clay",
  "Square", "Toast", "Mindbody",
  "Notion", "Airtable", "Google Sheets",
];

export const IntegrationsGrid = () => {
  return (
    <div className="rounded-2xl border border-border bg-card p-6 md:p-10">
      <div className="text-center mb-8">
        <h3 className="text-2xl md:text-3xl font-bold">Switch in one click from 25+ tools</h3>
        <p className="text-muted-foreground mt-2">
          Bring your clients, invoices, and history with you. Our migration concierge handles the rest.
        </p>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
        {TOOLS.map((tool) => (
          <div
            key={tool}
            className="flex items-center justify-center rounded-lg border border-border bg-background px-3 py-3 text-xs sm:text-sm font-medium text-foreground/80 hover:border-primary hover:text-primary hover:shadow-sm transition-all"
          >
            {tool}
          </div>
        ))}
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 text-sm text-muted-foreground">
        <ArrowRight className="h-4 w-4" />
        <span>Don't see yours? We'll migrate any CSV.</span>
      </div>
    </div>
  );
};
